import React, { useState} from "react";
import Subheader from '../../component/Subheader'
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

export default function Contact() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);

    const currentUrl = typeof window !== "undefined" ? window.location.href : "";
    const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
    const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    state: "",
    messages: "",
    source_url: sourceUrl,
    ip_address: currentUrl,
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === "fname" || name === "lname") {
            updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
        }

        if (name === "mobile") {
            updatedValue = value.replace(/[^0-9]/g, "");
        }

        setFormData(prev => ({
            ...prev,
            source_url: sourceUrl,
            ip_address: currentUrl,
            [name]: updatedValue,
        }));
    };


    const handleCaptcha = (value) => {
        setCaptchaToken(value);
    };


    const handleSubmit = async (e) => { 
        e.preventDefault();

         if (!formData.fname.trim()) {
            toast.error("First Name is required.");
            return;
        }

        if (!/^[a-zA-Z\s]+$/.test(formData.fname)) {
            toast.error("First Name should contain only letters.");
            return;
        }

        if (!formData.lname.trim()) {
            toast.error("Last Name is required.");
            return;
        }

        if (!/^[a-zA-Z\s]+$/.test(formData.lname)) {
            toast.error("Last Name should contain only letters.");
            return;
        }

        if (!formData.mobile.trim()) {
            toast.error("Phone Number is required.");
            return;
        }

        if (!/^[0-9]+$/.test(formData.mobile)) {
            toast.error("Phone Number should contain only digits.");
            return;
        }

        if (formData.mobile.length !== 10) {
            toast.error("Phone Number should be exactly 10 digits long.");
            return;
        }

        if (!formData.state.trim()) {
            toast.error("State is required.");
            return;
        }

        if (!captchaToken) {
            toast.error("Please complete the CAPTCHA");
            return;
        }

        try {
            setLoading(true);
            const response = await fetch(`${BaseUrl}/api/contact-saves`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.success === true) {
            navigate("/thankyou");
            } else {
            toast.error(result.message)
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong while submitting the form.");
        } finally {
            setLoading(false);
        }
    }


    const subheadData = {
      image: '../image/contact-banner.webp',
      heading: 'Your Dream Ensemble Is Just a Conversation Away',
      pagename: 'Contact Us',
    }

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
        "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
        "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
        "Uttar Pradesh", "Uttarakhand", "West Bengal",
        "Andaman and Nicobar Islands", "Chandigarh",
        "Dadra and Nagar Haveli and Daman and Diu", "Delhi (NCT)",
        "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>

    <section className="contactpage">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-8 col-md-10">
                    <div className="contact-detail">
                        <h1 className="heading">Contact Us</h1>
                        <img src="/image/shape.webp" alt="shape" className='divider-shape' loading="lazy"/>
                        <p>From queries to couture - we’re here to help you shine, connect with us to bring your bridal story to life</p>
                        
                        <ul>
                            <li><img src="/image/phone.svg" alt="phone" loading="lazy"/>
                                <Link to="tel:+91 9552221979"> +91 955 222 1979</Link>
                            </li>
                            <li><img src="/image/mail.svg" alt="email" loading="lazy"/>
                                <Link to="mailto:info@sonamlabel.com">info@sonamlabel.com</Link>
                            </li>
                            <li><img src="/image/location.svg" alt="location" loading="lazy"/>
                                <span>Lodha Belmondo, Tower 11, Pune</span>
                            </li>   
                        </ul>
                    </div>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <input value={formData.fname} onChange={handleChange} type="text" name="fname" placeholder="First Name*" className="form-control"/>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <input value={formData.lname} onChange={handleChange} type="text" name="lname" placeholder="Last Name*" className="form-control"/>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <input value={formData.email} onChange={handleChange} name="email" type="email" placeholder="Email*" className="form-control" />
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <input value={formData.mobile} onChange={handleChange}
                                name="mobile" type="tel" maxLength={10} placeholder="Phone" className="form-control" inputMode="numeric"/>
                            </div>

                            <div className="col-lg-12">
                                <select value={formData.state} onChange={handleChange} name="state" className="form-control">
                                    <option value="">Select State*</option>
                                    {indianStates.map((state, index) => (
                                        <option key={index} value={state}>{state}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-lg-12">
                                <textarea value={formData.messages} onChange={handleChange} name="messages" placeholder="Message" className="form-control" />
                            </div>

                            <div className="col-lg-12 mb-3">
                                <ReCAPTCHA sitekey="6Lf3ClosAAAAAHBljufC2cFazfRU5LAe-0BQMprO" onChange={handleCaptcha}/>
                            </div>

                            <div className="col-lg-12">
                                <button type="submit" className="default-btn red-default" disabled={loading}>
                                    {loading ? "submitting..." : "submit Now"} 
                                </button>
                            </div>
                        </div>
                    </form> 
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
